export const EventUtil = {
    cancel : (event) => {
        event.preventDefault();
        event.stopPropagation();
    }
}